module.exports = __webpack_public_path__ + "static/BrandonGrotesque-SemiBold-f21160dd71386b02be50d943ea6ca2f4.ttf";